// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"f0c965af","68":"ffcfd4fe","507":"6865aab2","583":"54e8c22c","599":"cfdccb15","871":"8caec1c6"}[chunkId] + ".chunk.js";
};